(function (window, document) {
  // --------------------
  // Elements
  // --------------------

  const $html = document.documentElement;
  const $header = document.querySelector('.s-header');

  // Unified bundle runs on every page; bail out where this header isn't present.
  if (!$header) {
    return;
  }

  if ($header.classList.contains('white')) {
    return;
  }

  // --------------------
  // Handlers
  // --------------------

  const checkScroll = function () {
    const scroll = window.scrollY || $html.scrollTop;

    // Page has been scrolled
    if (scroll > 0) {
      // Change color to white, add shadow
      $header.classList.add('white');
      $header.classList.add('shadow');
    }

    // Scroll position is at origin
    else {
      // Restore color, remove shadow
      $header.classList.remove('white');
      $header.classList.remove('shadow');
    }
  };

  // --------------------
  // Init
  // --------------------

  window.addEventListener('scroll', checkScroll);
  checkScroll();
})(window, document);
